import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import AccoutSetting from "../../components/AccountSettings";
import { BsFillPersonFill } from "react-icons/bs";
import { AiFillHome } from "react-icons/ai";
import { HiOutlineLanguage } from "react-icons/hi2";
import { FEEDBACK } from "../../constants/settingsStrings.js";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import CustomizedSlider from "../../components/Slider";
import { useUserInfor } from "../../hooks/api/useAuth.js";
import { Link } from "react-router-dom";
import Topbar from "../../components/Topbar";
import { addFeedBack } from "../../hooks/api/useFeedback.js";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

function FeedBack() {
  const { data: user, isLoading, error: inforError } = useUserInfor();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contactInfo, setContactInfo] = useState("");

  // Update user mutation
  const {
    error,
    isSuccess: postSuccess,
    isPending,
    mutate: postFeedBack,
  } = useMutation({
    mutationFn: addFeedBack,
  });

  useEffect(() => {
    const user_ = user?.data?.user ? user?.data?.user : null;
    if (user_) {
      setName(user_.name || "");
      setEmail(user_.email || "");
      setContactInfo(user_?.contact || "");
    }
  }, [user]);

  const [slideValue, setSlideValue] = useState(30);
  const onSliding = (e) => {
    setSlideValue(e.target.value);
  };
  useEffect(() => {
    if (postSuccess) {
      setFeedbackMessage("")
      toast.success("Feedback posted Successfully");
    }
    if (error) {
      toast.error("Failed to post feedback, please try again");
    }
  }, [postSuccess, error]);

  const [feedbackMessage, setFeedbackMessage] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    postFeedBack({
      name,
      email,
      contactInfo,
      message: feedbackMessage,
      rating: slideValue,
    });
  };

  return (
    <div className="dark:bg-black  bg-white h-screen  overflow-hidden">

      <Topbar />
      <div className="md:block hidden">
        {" "}
        <Header />
      </div>
      <div className=" sm:flex bg-white  dark:bg-black sm:items-center sm:space-x-10 sm:px-10 sm:mt-5 sm:justify-center">
        <div className="hidden md:block">
          {" "}
          <AccoutSetting active={FEEDBACK} />
        </div>
        <div className="sm:shadow-lg  rounded-[25px] bg-white dark:bg-black sm:w-[874px] sm:h-[454px] mt-2 overflow-hidden">
          <div className="flex  space-x-[100px] px-3">
            <Link to="/settings">
              {" "}
              <ArrowLeftIcon color="gray" className="w-10 h-10 sm:hidden" />
            </Link>

            <h3 className="grid  place-content-center font-bold text-[20px] dark:text-white ">
              Feedback
            </h3>
          </div>

          <div className="sm:flex sm:space-x-14">
            {" "}
            <form action="">
              <div className="mt-5  sm:space-y-3 space-y-9 sm:w-full sm:h-full ml-3">
                <div className="sm:flex-col flex space-x-8 sm:space-x-0">
                  <div>
                    <label className="text-[#2071B2] font-semibold dark:text-white">
                      {" "}
                      Name
                    </label>
                    <div className=" border w-full sm:w-[356px] sm:h-[38px] dark:bg-white  h-[38px] rounded-[10px]  grid place-content-center items-center">
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                        className="outline-none  w-[155px]  text-black   dark:bg-white sm:w-[350px] dark:text- px-3 "
                      />
                    </div>
                  </div>

                  <div className="">
                    <label className="text-[#2071B2] font-semibold dark:text-white">
                      Contact Number
                    </label>
                    <div className="  border w-[160px]  sm:w-[356px] sm:h-[38px] dark:bg-white  h-[38px] rounded-[10px] grid place-content-center items-center">
                      <input
                        type="text"
                        value={contactInfo}
                        onChange={(e) => {
                          setContactInfo(e.target.value);
                        }}
                        className="outline-none  w-[155px] bg-white  dark:bg-white  dark:text-black sm:w-[350px]  px-3"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <label className="text-[#2071B2] font-semibold dark:text-white">
                    Email Address
                  </label>
                  <div className="border w-[160px] sm:w-[356px] sm:h-[38px] dark:bg-white  h-[38px] rounded-[10px] items-center grid place-content-center">
                    <input
                      type="text"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      className="outline-none sm:ml-0  dark:text:-white w-[155px]  bg-white dark:bg-white  dark:text-black sm:w-[350px] px-3"
                    />
                  </div>
                </div>
              </div>
            </form>
            <div className=" sm:hidden m-5 ">
              <h3 className="text-[#2071B2] sm:font-semibold mb-4  sm:text-[12px] text-[18px] font-bold dark:text-white">
                Share your experience in scaling
              </h3>
              <div className="flex  space-x-10  ">
                <div className="">
                  <div
                    className={`text-[1.7rem] ${
                      slideValue < 20 ? "" : "opacity-20"
                    }`}
                  >
                    &#128534;
                  </div>
                  <h3 className="text-[#105955] font-semibold text-[12px] dark:text-white">
                    Worse
                  </h3>
                </div>
                <div className="">
                  <div
                    className={` text-[1.7rem] ${
                      slideValue > 20 && slideValue < 40 ? "" : "opacity-20"
                    }`}
                  >
                    &#128577;
                  </div>
                  <h3
                    className={` ${
                      slideValue > 20 && slideValue < 40
                        ? " text-[#105955]"
                        : " text-[#A5E0DD]"
                    }} text-[12px] dark:text-white  `}
                  >
                    Not <br /> Good
                  </h3>
                </div>
                <div>
                  <div
                    className={` text-[1.7rem] ${
                      slideValue > 40 && slideValue < 60
                        ? "text-[#105955]"
                        : "text-[#A5E0DD]"
                    }`}
                  >
                    &#128528;
                  </div>
                  <h3
                    className={` text-[1.7rem] ${
                      slideValue > 40 && slideValue < 60 ? "" : "opacity-20"
                    }`}
                  >
                    {" "}
                    Fine
                  </h3>
                </div>

                <div className="">
                  <div
                    className={` text-[1.7rem] ${
                      slideValue > 60 && slideValue < 80 ? "" : "opacity-20"
                    }`}
                  >
                    &#128512;
                  </div>
                  <h3 className="text-[#A5E0DD] text-[12px] dark:text-white">
                    Look <br /> Good
                  </h3>
                </div>
                <div className="">
                  <div
                    className={` text-[1.7rem] ${
                      slideValue > 80 ? "" : "opacity-20"
                    }`}
                  >
                    &#128525;
                  </div>
                  <h3 className="text-[#A5E0DD] text-[12px] dark:text-white">
                    Very <br /> Good
                  </h3>
                </div>
              </div>
              <CustomizedSlider value={slideValue} onSliding={onSliding} />
            </div>
            <textarea
              id="message"
              rows="4"
              value={feedbackMessage}
              onChange={(e) => setFeedbackMessage(e.target.value)}
              className="block p-2.5 sm:mt-10 m-5  w-[350px] bg-white after: dark:bg-white dark:text-black  sm:mr-6 text-sm text-gray-900 rounded-[9px] border border-gray-300 sm:w-[398px] focus:ring-blue-500 focus:border-blue-5 dark:border-gray-600 dark:placeholder-gray-400  dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Add your comment here..."
            ></textarea>
          </div>
          <div className="  items-center">
            <h3 className="text-[#2071B2] font-semibold md:block hidden text-[12px] ml-3 dark:text-white">
              Share your experience in scaling
            </h3>
            <div className=" md:block hidden ml-3 ">
              <div className="flex  space-x-4  ">
                <div className="">
                  <div
                    className={` text-[1.7rem] ${
                      slideValue < 20 ? "" : "opacity-20"
                    }`}
                  >
                    &#128534;
                  </div>
                  <h3 className="text-[#105955] font-semibold text-[12px] dark:text-white">
                    Worse
                  </h3>
                </div>
                <div className="">
                  <div
                    className={` text-[1.7rem] ${
                      slideValue > 20 && slideValue < 40 ? "" : "opacity-20"
                    }`}
                  >
                    &#128577;
                  </div>
                  <h3 className="text-[#A5E0DD] text-[12px] dark:text-white">
                    Not <br /> Good
                  </h3>
                </div>
                <div>
                  <div
                    className={` text-[1.7rem] ${
                      slideValue > 40 && slideValue < 60 ? "" : "opacity-20"
                    }`}
                  >
                    &#128528;
                  </div>
                  <h3 className="text-[#A5E0DD] text-[12px] dark:text-white">
                    {" "}
                    Fine
                  </h3>
                </div>

                <div className="">
                  <div
                    className={` text-[1.7rem] ${
                      slideValue > 60 && slideValue < 80 ? "" : "opacity-20"
                    }`}
                  >
                    &#128512;
                  </div>
                  <h3 className="text-[#A5E0DD] text-[12px] dark:text-white">
                    Look <br /> Good
                  </h3>
                </div>
                <div className="">
                  <div
                    className={` text-[1.7rem] ${
                      slideValue > 80 ? "" : "opacity-20"
                    }`}
                  >
                    &#128525;
                  </div>
                  <h3 className="text-[#A5E0DD] text-[12px] dark:text-white">
                    Very <br /> Good
                  </h3>
                </div>
              </div>
              <CustomizedSlider value={slideValue} onSliding={onSliding} />
            </div>
            <div className="sm:justify-end items-center sm:ml-[490px]">
              <button
                type="submit"
                className="bg-blue-500 text-white px-4 py-2 rounded mt-4"
                disabled={isPending}
                onClick={handleSubmit}
              >
                {isPending ?  <l-tail-chase size="25" speed="1.75" color="black"></l-tail-chase> : "Submit"}
              </button>
            </div>

            <div className=" flex justify-between rounded-b-50   sm:hidden px-5  mr-10 bg-[#2A71E8] fixed bottom-0 items-center h-[76px] w-[390px] ">
              <AiFillHome color="white" size={35} />
              <HiOutlineLanguage color="white" size={35} />
              <BsFillPersonFill color="white" size={35} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeedBack;
